<script setup>
import { Checkbox } from '@/components/ui/checkbox'
import { Input } from '@/components/ui/input'

const props = defineProps({
    specifics: {
        type: Array,
        default: () => [],
    },
    tempValues: {
        type: Object,
        default: () => ({}),
    },
})

const emit = defineEmits([
    'update:tempValues',
    'validate-input-key-press',
])

const hasRangeValue = (specificItem, bound) => {
    const value = props.tempValues?.[specificItem.key]?.[bound]

    return value !== null && value !== undefined && value !== ''
}

const getRangeValue = (specificItem, bound) => props.tempValues?.[specificItem.key]?.[bound] ?? ''

const getInputMin = (specificItem) => specificItem.inputMin ?? 0

const updateBooleanValue = (specificItem, value) => {
    emit('update:tempValues', {
        ...props.tempValues,
        [specificItem.key]: value,
    })
}

const updateRangeValue = (specificItem, bound, value) => {
    const currentValue = props.tempValues?.[specificItem.key] || { min: '', max: '' }

    emit('update:tempValues', {
        ...props.tempValues,
        [specificItem.key]: {
            ...currentValue,
            [bound]: value,
        },
    })
}
</script>

<template>
    <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
        <div
            v-for="specificItem in specifics"
            :key="specificItem.key"
            class="space-y-2"
        >
            <label class="text-sm font-medium text-slate-700">
                {{ specificItem.label }}
            </label>

            <div v-if="specificItem?.type === 'boolean'" class="flex h-10 items-center">
                <Checkbox
                    :checked="tempValues[specificItem.key]"
                    @update:checked="value => updateBooleanValue(specificItem, value)"
                />
            </div>

            <div v-else class="flex items-center gap-3">
                <div class="relative w-full">
                    <Input
                        :model-value="getRangeValue(specificItem, 'min')"
                        type="number"
                        :min="getInputMin(specificItem)"
                        placeholder="Min"
                        class="h-9 pr-8"
                        @update:model-value="value => updateRangeValue(specificItem, 'min', value)"
                        @keypress="event => emit('validate-input-key-press', event, specificItem)"
                    />
                    <div
                        v-if="specificItem?.format?.isPercentage === true && hasRangeValue(specificItem, 'min')"
                        class="pointer-events-none absolute inset-y-0 right-3 flex items-center text-sm font-semibold text-slate-400"
                    >
                        %
                    </div>
                </div>

                <span class="text-sm text-slate-400">-</span>

                <div class="relative w-full">
                    <Input
                        :model-value="getRangeValue(specificItem, 'max')"
                        type="number"
                        :min="getInputMin(specificItem)"
                        placeholder="Max"
                        class="h-9 pr-8"
                        @update:model-value="value => updateRangeValue(specificItem, 'max', value)"
                        @keypress="event => emit('validate-input-key-press', event, specificItem)"
                    />
                    <div
                        v-if="specificItem?.format?.isPercentage === true && hasRangeValue(specificItem, 'max')"
                        class="pointer-events-none absolute inset-y-0 right-3 flex items-center text-sm font-semibold text-slate-400"
                    >
                        %
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
